import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import MfproductEditFormImpl from './MfproductEditFormImpl';
import MfproductList from './MfproductList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import MfproductListView from './MfproductListView'


export default function MfproductDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.manufslice.mfproductDashboard);
  const [ mfproductId, setMfproductId] = React.useState('');
  const [reloadMfproductList, setReloadMfproductList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <MfproductEditFormImpl 
            setReloadMfproductList={setReloadMfproductList}
            mfproductId={mfproductId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <MfproductListView 
                      setMfproductId = {setMfproductId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
